import { render, staticRenderFns } from "./goods.drawer.vue?vue&type=template&id=dd079672&scoped=true"
import script from "./goods.drawer.vue?vue&type=script&lang=js"
export * from "./goods.drawer.vue?vue&type=script&lang=js"
import style0 from "./goods.drawer.vue?vue&type=style&index=0&id=dd079672&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd079672",
  null
  
)

export default component.exports